import { Grid, ListItemIcon, ListItemText, Chip, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../../Constants/Routes";
import { Container, MenuItem, Menu, Subtitle } from "./styles";
import { useState } from "react";
import { PermissionId, useAuth } from "../../../Contexts/AuthContext";
import { useSupport } from "../../../Contexts/SupportContext";



export const MenuNavigation = () => {
  let location = useLocation();

  const { hasPermission } = useAuth();
  const { unread } = useSupport();

  return (
    <Container container spacing={2}>
      <Grid item xs={12}>
        <Subtitle gutterBottom variant="subtitle2">
          MENU
        </Subtitle>
        <Menu>
          {routes.filter(e => !!e.icon).map((el, index) => {
            if (el?.isHidden) {
              return;
            }

            if(el.permission && !hasPermission(el.permission)) {
              return;
            }

            const Icon = el?.icon;
            return (
              <Link key={index} to={el?.path}>
                <MenuItem
                  style={{ padding: 10 }}
                  key={index}
                  isSelected={location.pathname === el?.path}
                >
                  <ListItemIcon>
                    <Icon />
                  </ListItemIcon>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <ListItemText primary={el.label} />
                    {el?.path === '/suporte' && unread > 0 && (
                      <Box sx={{ ml: 'auto' }}>
                        <Chip label={unread} color="error" size="small" sx={{ height: 20, '& .MuiChip-label': { px: 0.75, color: 'common.white', fontWeight: 700 } }} />
                      </Box>
                    )}
                  </Box>
                </MenuItem>
              </Link>
            );
          })}
        </Menu>
      </Grid>
    </Container>
  );
};
